type Props = {
    goBack: () => void;
    title: string;
    subTitle?: string;
};

const AppHeader: React.FC<Props> = ({ goBack, title, subTitle }) => {
    // const title = patientPersonalProfile?.name || '';
    // const subTitle = `${getAgeString(
    //     {
    //         age: patientPersonalProfile?.age?.value,
    //         month: patientPersonalProfile?.age?.month,
    //         dob: patientPersonalProfile?.age?.dob,
    //     },
    //     undefined,
    //     ' / ',
    // )}${patientPersonalProfile?.gender ? `${patientPersonalProfile.gender} / ` : ''} ${
    //     patientPersonalProfile?.phone.c
    // } ${patientPersonalProfile?.phone.n}`;

    return (
        <div className="flex items-center justify-between bg-white border-b border-neutral-7 home-header-shadow">
            <div className="flex items-center">
                <div
                    onClick={goBack}
                    className="flex items-center justify-center ripple px-24 py-20"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        className="fill-text-primary"
                        width="22"
                        height="22"
                    >
                        <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path>
                    </svg>
                </div>
                <div>
                    <p className="leading-6 text-18 text-text-primary font-700">{title}</p>
                    <p className="leading-5 text-text-secondary text-12 font-700">{subTitle}</p>
                </div>
            </div>
        </div>
    );
};

export default AppHeader;
